import React, {useState, useEffect, useRef} from 'react'
import '../App.css';
import './TShirtFormCard.css';
import {Link} from "react-router-dom";
import { ProForm,ProFormRadio } from '@ant-design/pro-components';
import { Input ,InputNumber , Select  ,DatePicker } from "antd";
const TShirtFormCard = () => {

    //now

    const [showSizeChat, setShowSizeChat] = useState(false);

    //before for bak
    const [cardNumber, setCardNumber] = useState('');
    const [purchaseQuantity, setPurchaseQuantity] = useState('');
    const [purchaseQuantitySize, setPurchaseQuantitySize] = useState(1);
    const [price, setPrice] = useState(0);
    const [payment, setPayment] = useState('');
    const [datedd, setDatedd] = useState('');
    const [datemm, setDatemm] = useState('');
    const [securityCode, setSecurityCode] = useState('');
    const [fullName, setFullName] = useState('');
    const [physicalAddress, setPhysicalAddress] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [colour, setColour] = useState('');
    const [matchesWithSizingOptions, setMatchesWithSizingOptions] = useState(0);
    const [selectedColler, setSelectedColler] = useState('');
    const [selectedSizing, setSelectedSizing] = useState('');
    const [directContactNumber, setDirectContactNumber] = useState('');
    const [materialType, setMaterialType] = useState('');
    const [materialSize, setMaterialSize] = useState('');
    const [dateInput, setDateInput] = useState('');
    const [showConfirmation, setShowConfirmation] = useState(0);
    const [showViewDisclaimerDiv, setShowViewDisclaimerDiv] = useState(0);
    const showConfirmationFlag = (flagNo) => {
        setShowConfirmation(flagNo);
    };
    const handleDateChange = (e) => {

        setDateInput(e.target.value);
    };
    const handlePurchaseQuantitySize = (e) => {
        setPurchaseQuantitySize(e.target.value)
    };
    const handleCollerChange = (e) => {
        setSelectedColler(e.target.value);
    };

    const [dotState, setDotState] = useState("0");
    // const [isMuted, setIsMuted] = useState(false);
    // const showDotState = (flagNo) => {
    //     setDotState(flagNo);
    // };
    const handleSizingRadioChange = (event) => {
        setSelectedSizing(event.target.value);
    };

    const handleTshirtSubmit = async (e) => {
        setShowConfirmation("2");
        e.preventDefault();
        const formData = {
            "emailAddress":emailAddress,
            "fullName":fullName,
            "directContactNumber":directContactNumber,
            "physicalAddress":physicalAddress,
            "sizing":selectedSizing,
            "collerType":selectedColler,
            "colour":colour,
            "purchaseQuantity":purchaseQuantity,
            "materialType":materialType,
            "size":materialSize,
            "totalPrice":price,
            "cardNumber":cardNumber,
            "expirationDate":dateInput,
            "securityCode":securityCode,
        };
        console.log("formData",formData);
        try {
            const response = await fetch('http://localhost:8080/saveThirtOrderForm', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            // Handle success
            alert('you already succeed save the form');
            window.location.reload(); // 保存成功后刷新当前页面
            console.log('Data sent successfully');
        } catch (error) {
            // Handle error
            console.error('There was a problem with the request:', error);
        }
    };

    const divRef = useRef(null); // 创建一个 ref
    const [divHeight, setDivHeight] = useState(0);

    const updateHeight = () => {
        if (divRef.current) {
            setDivHeight(divRef.current.clientHeight);
        }
    };

    // 定义一个 state 保存当前页面的宽度
    const [width, setWidth] = useState(window.innerWidth);

    // 定义一个函数来更新宽度
    const handleResize = () => {
        setWidth(window.innerWidth);
    };
    useEffect(() => {
        // 初始化高度
        updateHeight();

        // 添加窗口 resize 事件监听器
        window.addEventListener('resize', updateHeight);
        // 添加事件监听器
        window.addEventListener('resize', handleResize);

        // 在组件卸载时移除监听器
        // 清理事件监听器
        return () => {
            window.removeEventListener('resize', updateHeight);
            window.removeEventListener('resize', handleResize);
        };
    }, []); // 空依赖数组表示这个 useEffect 只在组件挂载和卸载时运行


  return (
      <div>
          <div className="tShirtBackGroundDiv">
              <div className="tShirt-text-container">
                  Order Confirmation
              </div>
              <label className="about-label-container">Confirm your order and payment details below</label>
          </div>

          <div className="page-container"  style={{
              display: showSizeChat ? 'none' : width<=960?"block":'flex',
          }}>
              <div className="filter-options">
                  <h3>Filter by Options</h3>
                  <div className="filter-section">
                      <p>Select A Colour</p>
                      {/*<label><input type="radio" name="color"/> White</label>*/}
                      <label className="radio-label">
                          <input type="radio" name="color" className="radio-input" /> White
                      </label>
                  </div>
                  <div className="filter-section">
                      <p>Sort by Pricing</p>
                      <label className="radio-label">
                          <input type="radio" name="pricing" className="radio-input" /> Lowest &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          <input type="radio" name="pricing" className="radio-input" /> Highest
                      </label>
                  </div>
                  <div className="filter-section">
                      <p>Select Garment Type</p>
                      {/*<label><input type="radio" name="type"/> Round Collar Tee-Shirt</label>*/}
                      <label className="radio-label">
                          <input type="radio" name="type" className="radio-input" /> Round Collar Tee-Shirt
                      </label>
                  </div>
                  <div className="filter-section">
                      <p>Select Garment Material</p>
                      {/*<label><input type="radio" name="material"/> Combined</label>*/}
                      <label className="radio-label">
                          <input type="radio" name="material" className="radio-input" /> Combined
                      </label>
                  </div>
                  <div className="filter-section">
                      <p>Select Size Group</p>
                      {/*<label><input type="radio" name="size"/> Small</label>*/}
                      {/*<label><input type="radio" name="size"/> Medium</label>*/}
                      <label className="radio-label">
                          <input type="radio" name="size" className="radio-input" /> Small &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          <input type="radio" name="size" className="radio-input" /> Medium
                      </label>
                      {/*<label><input type="radio" name="size"/> Large</label>*/}
                      {/*<label><input type="radio" name="size"/> XL</label>*/}
                      {/*<label><input type="radio" name="size"/> 2XL</label>*/}
                      {/*<label><input type="radio" name="size"/> 3XL</label>*/}
                      {/*<label><input type="radio" name="size"/> 4XL</label>*/}
                      {/*<label><input type="radio" name="size"/> 5XL</label>*/}
                  </div>
                  <div className="filter-section">
                      <label className="radio-label">
                          <input type="radio" name="size" className="radio-input" /> Large &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          <input type="radio" name="size" className="radio-input" /> XL
                      </label>
                  </div>
                  <div className="filter-section">
                      <label className="radio-label">
                          <input type="radio" name="size" className="radio-input" /> 2XL &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          <input type="radio" name="size" className="radio-input" /> 3XL
                      </label>
                  </div>
                  <div className="filter-section">
                      <label className="radio-label">
                          <input type="radio" name="size" className="radio-input" /> 4XL &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          <input type="radio" name="size" className="radio-input" /> 5XL
                      </label>
                  </div>
                  <button className="size-chart-button" onClick={(e) => setShowSizeChat(true)}><label className="sizeChart">Size Chart</label></button>
              </div>

              <div className="product-options">
                  <h2>T-Shirt Product Options</h2>
                  <div className="tabs">
                      <button><label className="labelStyle">All Products</label></button>
                      <button><label className="labelStyle">C-Force - T190: Tiaki Taonga Trust</label></button>
                      <button><label className="labelStyle">C-Force - T190: He Wakaputanga</label></button>
                  </div>
                  <div className="tabs">
                      <button><label className="labelStyle">K -CF T600: Tiaki Taonga Trust</label></button>
                      <button><label className="labelStyle">K -CF T600: He Wakaputanga</label></button>
                  </div>
                  <div className="product-grid">
                      <div className="product-card">
                          <div className="tShirtDivRight"></div>
                          <p className="product-title">Tiaki Taonga Trust T-Shirt</p>
                          <p className="product-title">Small (14) | CF - T190</p>
                          <label className="radio-label">
                              <input type="radio" name="color1" className="radio-input" /> White
                          </label>
                          <div className="price-info">
                              <p>Unisex</p>
                              <p>$101.00</p>
                          </div>
                          <button className="order-now">Order Now</button>
                      </div>
                      <div className="product-card">
                          <div className="tShirtDivRight2"></div>
                          <p className="product-title">He Wakaputanga T-Shirt</p>
                          <p className="product-title">Small (14) | CF - T190</p>
                          <label className="radio-label">
                              <input type="radio" name="color1" className="radio-input" /> White
                          </label>
                          <div className="price-info">
                              <p>Unisex</p>
                              <p>$101.00</p>
                          </div>
                          <button className="order-now">Order Now</button>
                      </div>
                      <div className="product-card">
                          {/*<img src="tshirt2.jpg" alt="Product 2"/>*/}
                          <div className="tShirtDivRight"></div>
                          <p className="product-title">Tiaki Taonga Trust T-Shirt</p>
                          <p className="product-title">Medium (16) | CF - T190</p>
                          <label className="radio-label">
                              <input type="radio" name="color1" className="radio-input" /> White
                          </label>
                          <div className="price-info">
                              <p>Unisex</p>
                              <p>$101.00</p>
                          </div>
                          <button className="order-now">Order Now</button>
                      </div>
                  </div>
                  <div className="product-grid">
                      <div className="product-card">
                          {/*<img src="tshirt1.jpg" alt="Product 1" />*/}
                          <div className="tShirtDivRight2"></div>
                          <p className="product-title">He Wakaputanga T-Shirt</p>
                          <p className="product-title">Small (14) | CF - T190</p>
                          <label className="radio-label">
                              <input type="radio" name="color1" className="radio-input" /> White
                          </label>
                          <div className="price-info">
                              <p>Unisex</p>
                              <p>$101.00</p>
                          </div>
                          <button className="order-now">Order Now</button>
                      </div>
                      <div className="product-card">
                          {/*<img src="tshirt2.jpg" alt="Product 2"/>*/}
                          <div className="tShirtDivRight"></div>
                          <p className="product-title">Tiaki Taonga Trust T-Shirt</p>
                          <p className="product-title">Medium (16) | CF - T190</p>
                          <label className="radio-label">
                              <input type="radio" name="color1" className="radio-input" /> White
                          </label>
                          <div className="price-info">
                              <p>Unisex</p>
                              <p>$101.00</p>
                          </div>
                          <button className="order-now">Order Now</button>
                      </div>
                      <div className="product-card">
                          {/*<img src="tshirt2.jpg" alt="Product 2"/>*/}
                          <div className="tShirtDivRight2"></div>
                          <p className="product-title">He Wakaputanga T-Shirt</p>
                          <p className="product-title">Large (18) | CF - T190</p>
                          <label className="radio-label">
                              <input type="radio" name="color1" className="radio-input" /> White
                          </label>
                          <div className="price-info">
                              <p>Unisex</p>
                              <p>$101.00</p>
                          </div>
                          <button className="order-now">Order Now</button>
                      </div>
                  </div>
              </div>
          </div>
          <div className="page-container"  style={{
              display: showSizeChat ? 'block' : 'none',
          }}>
              <div className="size-chart-container">
                  <a href="#" className="back-link" onClick={(e) => setShowSizeChat(false)}>← Back to Products</a>
                  <section>
                      <h2>C-Force - T190 T-Shirts</h2>
                      <div className="size-chart">
                          <div className="size-chart-column">
                              <h3>Unisex</h3>
                              <div className="size-row header">
                                  <span>Size</span>
                                  <span>1/2 Chest</span>
                              </div>
                              <div className="size-row">
                                  <span>2</span>
                                  <span>34</span>
                              </div>
                              <div className="size-row">
                                  <span>4</span>
                                  <span>36</span>
                              </div>
                              <div className="size-row">
                                  <span>6</span>
                                  <span>39</span>
                              </div>
                              <div className="size-row">
                                  <span>8</span>
                                  <span>42</span>
                              </div>
                              <div className="size-row">
                                  <span>10</span>
                                  <span>45</span>
                              </div>
                              <div className="size-row">
                                  <span>12</span>
                                  <span>48</span>
                              </div>
                              <div className="size-row">
                                  <span>14</span>
                                  <span>51</span>
                              </div>
                              <p className="note">These are not body measures</p>
                          </div>
                          <div className="size-chart-column">
                              <h3>Adult (Unisex)</h3>
                              <div className="size-row header">
                                  <span>Size</span>
                                  <span>1/2 Chest</span>
                              </div>
                              <div className="size-row">
                                  <span>5XL</span>
                                  <span>75</span>
                              </div>
                              <div className="size-row">
                                  <span>7XL</span>
                                  <span>81</span>
                              </div>
                              <div className="size-row">
                                  <span>8XL</span>
                                  <span>85</span>
                              </div>
                              <div className="size-row">
                                  <span>9XL</span>
                                  <span>90</span>
                              </div>
                              <div className="size-row">
                                  <span>10XL</span>
                                  <span>95</span>
                              </div>
                              <div className="size-row">
                                  <span>11XL</span>
                                  <span>100</span>
                              </div>
                              <div className="size-row">
                                  <span>&nbsp;</span>
                                  <span></span>
                              </div>
                              <p className="note">These are not body measures</p>
                          </div>
                      </div>
                  </section>
                  <section>
                      <h2>K-CF - T600</h2>
                      <div className="size-chart">
                          <div className="size-chart-column">
                              <h3>Unisex</h3>
                              <div className="size-row header">
                                  <span>Size</span>
                                  <span>1/2 Chest</span>
                              </div>
                              <div className="size-row">
                                  <span>2</span>
                                  <span>34</span>
                              </div>
                              <div className="size-row">
                                  <span>4</span>
                                  <span>36</span>
                              </div>
                              <div className="size-row">
                                  <span>6</span>
                                  <span>39</span>
                              </div>
                              <div className="size-row">
                                  <span>8</span>
                                  <span>42</span>
                              </div>
                              <div className="size-row">
                                  <span>10</span>
                                  <span>45</span>
                              </div>
                              <div className="size-row">
                                  <span>12</span>
                                  <span>48</span>
                              </div>
                              <div className="size-row">
                                  <span>14</span>
                                  <span>51</span>
                              </div>
                              <p className="note">These are not body measures</p>
                          </div>
                          <div className="size-chart-column">
                              <h3>Adult (Unisex)</h3>
                              <div className="size-row header">
                                  <span>Size</span>
                                  <span>1/2 Chest</span>
                              </div>
                              <div className="size-row">
                                  <span>5XL</span>
                                  <span>75</span>
                              </div>
                              <div className="size-row">
                                  <span>7XL</span>
                                  <span>81</span>
                              </div>
                              <div className="size-row">
                                  <span>8XL</span>
                                  <span>85</span>
                              </div>
                              <div className="size-row">
                                  <span>9XL</span>
                                  <span>90</span>
                              </div>
                              <div className="size-row">
                                  <span>10XL</span>
                                  <span>95</span>
                              </div>
                              <div className="size-row">
                                  <span>11XL</span>
                                  <span>100</span>
                              </div>
                              <div className="size-row">
                                  <span>&nbsp;</span>
                                  <span></span>
                              </div>
                              <p className="note">These are not body measures</p>
                          </div>
                      </div>
                  </section>
              </div>

          </div>




      </div>
  );
}
export default TShirtFormCard